module.exports = __webpack_public_path__ + "static/img/barlowcondensed-medium-webfont.2beb98e.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/barlowcondensed-medium-webfont.svg
// module id = 209
// module chunks = 0